import {commonActions} from '../../actions/commonActions';
import {reminderSetList,reminderSetListForExcel} from '../../actions/reminderActions';
import {connect} from 'react-redux';
import List from '../../components/reminder/ReminderList';
import {API_FETCH} from '../../services/FetchService';
import {commonConstants} from "../../constants";
import {getItem as stateInfo} from '../../containers/area/AddEditStateFormPage';
import {list as productList} from "../product/ProductListPage";
import {list as areaList} from "../area/AreaListPage";



const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getStateInfo: (id) => {
        return(dispatch(stateInfo(id)))
    },
    getList: (value) => {
        dispatch(list(value));
    },
    getListForExcel: (value) => {
        dispatch(listForExcel(value));
    },
    getProductList: (value) => {
        dispatch(productList(value));
    },
    getAreaList : () => {
        return(dispatch(areaList()));
    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Search Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(list(value));
    },

});

export const listForExcel = (value) => {
    return (dispatch, getState) => {
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.get('reminder',{params: value}).then(list => {
            if(list.status === 201) {
                dispatch({type: commonConstants.FORM_SUCCESS});
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
            }
            dispatch(reminderSetListForExcel(list.data));
        }).catch(error => {
            console.log(error);
        });
    }

}

const list = (value) => {
    return (dispatch, getState) => {
        if(value) {
            if(value.created_from && value.created_from._d)
                value.created_from = value.created_from._d.toISOString()
            if(value.created_to && value.created_to._d)
                value.created_to = value.created_to._d.toISOString()
        }
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.get('reminder',{params: value}).then(list => {
            dispatch(reminderSetList(list.data));
            if(list.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
            }
        }).catch(error => {
            console.log(error);
        });
    }

}

const mapStateToProps = state => {
    return {
        userValue    : state.app.currentUser,
        list         : state.reminder.list,
        common       : state.common,
        stateInfo    : state.area.stateTargetItem,
        listForExcel : state.reminder.listForExcel,
        productList  : state.product.list,
        areaList     : state.area.areaList,
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(List);
